import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'

import { AcceptableIdModal } from '../../acceptable-id-modal'
import { Picture } from '../splash-picture'
import { governmentId as gId } from '../strings'
import { GOVERNMENT_ID_URL } from './constants'

import { Photo } from '../../../../models/types'
import { compressImage } from '../../../../utilities/imageCompression'

type Props = {
  goToNextStep: () => void
  setPhotoIdFront: (image: Photo) => void
}

type State = {
  isShowingModal: boolean
}

declare const document

export class GovernmentId extends React.Component<Props, State> {
  public state = {
    isShowingModal: false,
  }

  public componentDidMount() {
    const { setPhotoIdFront, goToNextStep } = this.props
    const input = document.createElement('input')
    input.id = 'governmentid'
    input.type = 'file'
    input.accept = 'image/*'
    input.style.display = 'none'
    document.body.appendChild(input)

    const event = async e => {
      const imageFile = e.target.files[0]

      const res = await compressImage(imageFile)

      setPhotoIdFront(res)

      input.removeEventListener('change', event, false)
      goToNextStep()
    }

    input.addEventListener('change', event, false)
  }

  public handleModalClicked = e => {
    e.stopPropagation()

    const isShowingModal = !this.state.isShowingModal
    this.setState({
      isShowingModal,
    })
  }

  public handleImportPhoto = () => {
    const input = document.getElementById('governmentid')
    input.click()
  }

  public render() {
    return (
      <StackChildren>
        <Text
          styles={Text.Styles.PageTitle}
          textAlign={Text.TextAlignments.Center}
          tag="h1"
        >
          {gId.title()}
        </Text>
        <Text
          styles={Text.Styles.ContentAction}
          textAlign={Text.TextAlignments.Center}
          tag="a"
          href="#"
          onClick={e => this.handleModalClicked(e)}
        >
          {gId.acceptableId()}
        </Text>
        {this.state.isShowingModal && (
          <AcceptableIdModal onClose={this.handleModalClicked.bind(this)} />
        )}
        <Picture srcSet={GOVERNMENT_ID_URL} />
        <Button onClick={this.handleImportPhoto} type={Button.Types.Primary}>
          {gId.primaryAction()}
        </Button>
      </StackChildren>
    )
  }
}

export default GovernmentId
